/* eslint-disable no-param-reassign */
export default function (el, binding) {
  el.style.visibility = binding.value ? 'visible' : 'hidden';
}
